// extracted by mini-css-extract-plugin
export var badge = "List-module--badge--883fe";
export var content = "List-module--content--89b46";
export var danger = "List-module--danger--70ef8";
export var description = "List-module--description--f59c6";
export var disabled = "List-module--disabled--e10d9";
export var heading = "List-module--heading--3fb52";
export var icon = "List-module--icon--15fb6";
export var info = "List-module--info--63028";
export var item = "List-module--item--6d7b7";
export var label = "List-module--label--0ea81";
export var list = "List-module--list--3bafa";
export var neutral = "List-module--neutral--cf0d3";
export var pointer = "List-module--pointer--bc774";
export var success = "List-module--success--528de";
export var value = "List-module--value--4a2e5";
export var warning = "List-module--warning--5dd2d";
export var withDescription = "List-module--withDescription--88f1a";